import React from 'react';
import { Helmet } from 'react-helmet-async';
var DaAppUrl = function (_a) {
    var url = _a.url;
    if (!url) {
        return null;
    }
    return (React.createElement(Helmet, null,
        React.createElement("meta", { property: "da:appurl", content: "DeviantArt://".concat(url) }),
        React.createElement("meta", { name: "apple-itunes-app", content: "app-id=925219396, app-argument=DeviantArt://".concat(url) }),
        React.createElement("link", { rel: "alternate", href: "android-app://com.deviantart.android.damobile/DeviantArt/".concat(url) })));
};
DaAppUrl.displayName = 'DaAppUrl';
export default DaAppUrl;
//# sourceMappingURL=DaAppUrl.js.map